module.exports = __webpack_public_path__ + "img/15.23bb986a.png";